import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.canvas.pdf');
import { OnInit, OnDestroy, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-nrich-canvas-pdf',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichCanvasPdfComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
    @Input() documentId: string = '';
    @Input() pdfName: string = '';
    @Input() currentPage: number = 1;

    @ViewChild('pdfCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
    @ViewChild('canvasContainer') containerRef!: ElementRef<HTMLDivElement>;

    public pdfDoc: any = null;
    public loading: boolean = true;
    public error: string = '';

    private renderTask: any = null;
    private pdfjsLib: any = null;
    private resizeObserver: ResizeObserver | null = null;
    private resizeTimer: any = null;
    private initialized: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadPdfjsLib();
    }

    public ngAfterViewInit() {
        this.initialized = true;
        if (this.pdfName) {
            this.loadPDF();
        }
        // 컨테이너 리사이즈 감지
        if (this.containerRef?.nativeElement) {
            this.resizeObserver = new ResizeObserver(() => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {
                    if (this.pdfDoc) this.renderPage(this.currentPage);
                }, 200);
            });
            this.resizeObserver.observe(this.containerRef.nativeElement);
        }
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) return;
        if (changes['pdfName'] && this.pdfName) {
            await this.loadPDF();
        }
        if (changes['currentPage'] && this.pdfDoc) {
            await this.renderPage(this.currentPage);
        }
    }

    public ngOnDestroy() {
        if (this.renderTask) {
            this.renderTask.cancel();
            this.renderTask = null;
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        clearTimeout(this.resizeTimer);
    }

    private async loadPdfjsLib() {
        if (this.pdfjsLib) return;
        const pdfjsLib = await import('pdfjs-dist');
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/portal/nrich/pdf.worker.min.mjs';
        this.pdfjsLib = pdfjsLib;
    }

    private async loadPDF() {
        if (!this.pdfjsLib || !this.pdfName) return;
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const pdfUrl = `/wiz/api/page.document.item/pdf_file?document_id=${encodeURIComponent(this.documentId)}`;
            this.pdfDoc = await this.pdfjsLib.getDocument(pdfUrl).promise;
            await this.renderPage(this.currentPage);
        } catch (e: any) {
            this.error = 'PDF 파일 로드 실패';
            console.error('PDF load error:', e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private async renderPage(pageNum: number) {
        if (!this.pdfDoc || !this.canvasRef?.nativeElement) return;

        // 이전 렌더링 취소
        if (this.renderTask) {
            this.renderTask.cancel();
            this.renderTask = null;
        }

        try {
            const page = await this.pdfDoc.getPage(pageNum);
            const canvas = this.canvasRef.nativeElement;
            const ctx = canvas.getContext('2d')!;

            // 컨테이너 너비에 맞춰 스케일 계산
            const container = this.containerRef?.nativeElement;
            const containerWidth = container ? container.clientWidth - 40 : 800;
            const viewport = page.getViewport({ scale: 1 });
            const scale = Math.min(containerWidth / viewport.width, 2.5);
            const scaledViewport = page.getViewport({ scale });

            canvas.width = scaledViewport.width;
            canvas.height = scaledViewport.height;

            this.renderTask = page.render({
                canvasContext: ctx,
                viewport: scaledViewport,
            });
            await this.renderTask.promise;
            this.renderTask = null;
        } catch (e: any) {
            if (e.name !== 'RenderingCancelledException') {
                console.error('PDF render error:', e);
            }
        }
    }
}

export default PortalNrichCanvasPdfComponent;